import { flagDE, flagEN, flagFR, flagNL } from '@infuse/ui/assets/flags';

export const languages = [
  {
    id: 1,
    label: 'Nederlands',
    value: 'nl',
    flag: flagNL,
    emoji: '🇳🇱'
  },
  {
    id: 2,
    label: 'English',
    value: 'en',
    flag: flagEN,
    emoji: '🇬🇧'
  },
  {
    id: 3,
    label: 'Deutsch',
    value: 'de',
    flag: flagDE,
    emoji: '🇩🇪'
  },
  {
    id: 4,
    label: 'Français',
    value: 'fr',
    flag: flagFR,
    emoji: '🇫🇷'
  }
];
